/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Empty_Nocollection_Description2Inputs */

const id_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih salah satu bagan di atas untuk melihat posisi.`)
};

const ms_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih salah satu carta di atas untuk melihat kedudukan.`)
};

const da_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et af diagrammerne ovenfor for at se positioner.`)
};

const de_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen der Charts oben aus, um Positionen zu sehen.`)
};

const en_us2_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick one of the charts above to see positions.`)
};

const es_es2_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige uno de los rankings de arriba para ver posiciones.`)
};

const es_mx2_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige uno de los gráficos de arriba para ver posiciones.`)
};

const fil_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng isa sa mga chart sa itaas upang makita ang mga posisyon.`)
};

const fr_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un classement ci-dessus pour voir les positions.`)
};

const it_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una delle classifiche qui sopra per vedere le posizioni.`)
};

const hu_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassz egy listát fent a pozíciók megtekintéséhez.`)
};

const nl_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een van de grafieken hierboven om posities te zien.`)
};

const no_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg et av diagrammene over for å se posisjoner.`)
};

const pl_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz jeden z wykresów powyżej, aby zobaczyć pozycje.`)
};

const pt_br2_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um dos gráficos acima para ver as posições.`)
};

const pt_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um dos gráficos acima para ver posições.`)
};

const ro_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alege unul dintre clasamentele de mai sus pentru a vedea pozițiile.`)
};

const fi_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse jokin yllä olevista listoista nähdäksesi sijoitukset.`)
};

const sv_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj en av listorna ovan för att se positioner.`)
};

const vi_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một trong các biểu đồ ở trên để xem vị trí.`)
};

const tr_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozisyonları görmek için yukarıdaki listelerden birini seçin.`)
};

const cs_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte jeden z grafů výše pro zobrazení pozic.`)
};

const bg_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете някоя от класациите по-горе, за да видите позиции.`)
};

const ru_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите один из чартов выше, чтобы увидеть позиции.`)
};

const uk_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть один із чартів вище, щоб побачити позиції.`)
};

const ar_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر أحد المخططات أعلاه لرؤية المراكز.`)
};

const hi_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान देखने के लिए ऊपर कोई चार्ट चुनें।`)
};

const th_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกหนึ่งในแผนภูมิด้านบนเพื่อดูตำแหน่ง`)
};

const ja_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上のチャートから1つ選んで順位を確認してください。`)
};

const zh_cn2_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择上方图表之一以查看排名。`)
};

const zh_hant1_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請選擇上方其中一個排行榜以查看排名。`)
};

const ko_components_performancetable_empty_nocollection_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위 차트 중 하나를 선택해 순위를 확인하세요.`)
};

/**
* | output |
* | --- |
* | "Pick one of the charts above to see positions." |
*
* @param {Components_Performancetable_Empty_Nocollection_Description2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_empty_nocollection_description2 = /** @type {((inputs?: Components_Performancetable_Empty_Nocollection_Description2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Empty_Nocollection_Description2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "ms") return ms_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "da") return da_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "de") return de_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "fil") return fil_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "fr") return fr_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "it") return it_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "hu") return hu_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "nl") return nl_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "no") return no_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "pl") return pl_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "pt") return pt_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "ro") return ro_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "fi") return fi_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "sv") return sv_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "vi") return vi_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "tr") return tr_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "cs") return cs_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "bg") return bg_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "ru") return ru_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "uk") return uk_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "ar") return ar_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "hi") return hi_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "th") return th_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "ja") return ja_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_empty_nocollection_description2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_empty_nocollection_description2(inputs)
	return ko_components_performancetable_empty_nocollection_description2(inputs)
});
export { components_performancetable_empty_nocollection_description2 as "components.performanceTable.empty.noCollection.description" }